import { render, staticRenderFns } from "./campaign-widget.vue?vue&type=template&id=5addf33b&"
import script from "./campaign-widget.vue?vue&type=script&lang=js&"
export * from "./campaign-widget.vue?vue&type=script&lang=js&"
import style0 from "./campaign-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports